import { FC } from "react";
import { observer } from "mobx-react-lite";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DialogTitle, DialogDescription, DialogHeader, DialogFooter } from "@/components/ui/dialog";
import { useStore } from "@/hooks/useStore";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { structure } from "@/endpoints/dryp/structure";

interface EnableIAndIModalProps {
	structureId: Dryp.StructureId;
	structureName: string;
	onSuccess?: () => void;
}

export const EnableIAndIModal: FC<EnableIAndIModalProps> = observer(({ structureId, structureName, onSuccess }) => {
	const {
		uiStore: { modalStore },
	} = useStore();
	const attachApi = useAsyncStateStore(structure.attachIAndISensors);

	const onEnable = async () => {
		try {
			await attachApi.fetch(structureId);
		} catch {
			return; // failure is surfaced through attachApi.error below
		}
		modalStore.close();
		toast.success(`I&I enabled for "${structureName}".`);
		onSuccess?.();
	};

	return (
		<>
			<DialogHeader>
				<DialogTitle>Enable I&I</DialogTitle>
				<DialogDescription>
					Are you sure you want to enable I&I for "{structureName}" so it can be configured?
				</DialogDescription>
			</DialogHeader>

			{attachApi.error && <p className="text-sm text-destructive">{attachApi.error.message}</p>}

			<DialogFooter>
				<Button variant="outline" onClick={() => modalStore.close()} disabled={attachApi.loading}>
					Cancel
				</Button>
				<Button onClick={onEnable} disabled={attachApi.loading}>
					{attachApi.loading ? "Enabling…" : "Enable"}
				</Button>
			</DialogFooter>
		</>
	);
});
